<o-toc-item-header
  [dataSource]="dataSource"
  [displayReady]="true"
  [emptyMessage]="(warningFilterEnabled() ? 'empty.notes.warnings' : 'empty.notes') | translate">
  <ng-container selectAll>
    <div class="select-unselect-actions">
      <a (click)="toggleAllSelection()">
        {{ (selectMode() ? "actions.unselectAll" : "actions.selectAll") | translate }}
      </a>
    </div>
  </ng-container>
  <ng-container actions>
    <div class="note__header">
      @if (noteService.canAttachMedia) {
        <div
          class="media-storage-info"
          [ngClass]="{
            'media-storage-limit-reached': store.mediaStorageUsed >= noteService.mediaStorageLimit
          }">
          {{
            "notes.medias.storage_used"
              | translate
                : { used: store.mediaStorageUsed | byteFormat, max: noteService.mediaStorageLimit | byteFormat }
          }}
        </div>
      }
      <div class="button-container">
        <button
          mat-icon-button
          class="note__actions--delete"
          color="primary"
          [disabled]="!dataSource.data.length"
          [matMenuTriggerFor]="deleteMenu">
          <mat-icon color="primary" svgIcon="delete"></mat-icon>
        </button>
        <button
          mat-icon-button
          class="note__actions--import"
          color="primary"
          [disabled]="!store.offlineSearchReady"
          [matMenuTriggerFor]="importMenu">
          <mat-icon color="primary" svgIcon="file-upload"></mat-icon>
        </button>
        <button
          mat-icon-button
          class="note__actions--export"
          color="primary"
          [matMenuTriggerFor]="exportMenu"
          [disabled]="!dataSource.data.length">
          <mat-icon color="primary" svgIcon="export"></mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container filters>
    @if (store.pubInfo.capabilities.notesInline) {
      <button mat-icon-button color="primary" class="note__filters--inline-warning" (click)="toggleWarningFilter()">
        <mat-icon
          [color]="noteService.hasNoteWarnings() ? 'warn' : 'primary'"
          [svgIcon]="warningFilterEnabled() ? 'warning_off' : 'warning'"></mat-icon>
      </button>
    }
  </ng-container>
</o-toc-item-header>

<mat-menu #deleteMenu="matMenu" class="note__actions--delete-all">
  <button mat-menu-item class="note__actions--delete-all" (click)="deleteSelectedNotes(true)">
    <mat-icon color="primary" svgIcon="delete"></mat-icon>
    {{ "actions.delete.all" | translate }}
  </button>
  <button
    mat-menu-item
    class="note__actions--delete-selection"
    (click)="deleteSelectedNotes()"
    [disabled]="!selectedNotes.selected.length">
    <mat-icon color="primary" svgIcon="delete"></mat-icon>
    {{ "actions.delete.selection" | translate }}
  </button>
</mat-menu>

<mat-menu #exportMenu="matMenu" class="note__actions--export-all">
  <button mat-menu-item class="shopping__actions--exportCSV" (click)="exportAsZip()">
    <mat-icon color="primary" svgIcon="export"></mat-icon>
    {{ "actions.export.all" | translate }}
  </button>
  <button
    mat-menu-item
    class="note__actions--export-selection"
    (click)="exportAsZip(true)"
    [disabled]="!selectedNotes.selected.length">
    <mat-icon color="primary" svgIcon="export"></mat-icon>
    {{ "actions.export.selection" | translate }}
  </button>
</mat-menu>

<mat-menu #importMenu="matMenu" class="note__actions--import-all">
  <button
    mat-menu-item
    class="note__actions--import-default"
    (click)="importFileInput.click()"
    [disabled]="!store.offlineSearchReady">
    <mat-icon color="primary" svgIcon="file-upload"></mat-icon>
    {{ "notes.import.default" | translate }}
    <input type="file" (change)="importNotes($event)" accept=".zip" #importFileInput />
  </button>
  <button
    mat-menu-item
    class="note__actions--import-as-author"
    (click)="importAsAuthorFileInput.click()"
    [disabled]="!store.offlineSearchReady">
    <mat-icon color="primary" svgIcon="file-upload"></mat-icon>
    {{ "notes.import.as_author" | translate }}
    <input type="file" (change)="importNotes($event, true)" accept=".zip" #importAsAuthorFileInput />
  </button>
</mat-menu>

<mat-table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="{{ itemType }}">
    <mat-header-cell mat-header-cell *matHeaderCellDef> {{ itemType }} </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element">
      <mat-checkbox
        disableRipple
        [name]="element._id"
        (click)="toggleSelection(element._id)"
        [checked]="selectedNotes.isSelected(element._id)" />
      <o-note
        oHistoric
        [historicData]="element"
        [from]="HistorySource.NOTES"
        [item]="element"
        (updateList)="updateDataSource()">
      </o-note>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
